const initialState = {
  theme: localStorage.getItem("m2dTheme") || 'light',
  sidebarOpen: window.innerWidth < 800 ? "0" : "1",
  alertMessage: "",
  alertType: "",
  alertOpen: 0,
  version: "1.1.0",
  role: JSON.parse(localStorage.getItem("m2dRole")) || null,

  projects: null,
  unapprovedProjects: null,
  projectNamesAndIdsOfUser: null,
  models: null,
  unapprovedModels: null,
  modelInputTypes: null,
  modelResultTypes: null,
  history: null,
  users: null,
  adminProjects: null,
  adminModels: null
};

export default function m2dReducer(state = initialState, action) {
  switch (action.type) {
    case "switchTheme": {
      const newTheme = state.theme === "dark" ? "light" : "dark";
      localStorage.setItem("m2dTheme", newTheme);
      return {
        ...state,
        theme: newTheme
      };
    }
    case "updateRole": {
      localStorage.setItem("m2dRole", JSON.stringify(action.value.role))
      return {
        ...state,
        role: action.value.role
      }
    }
    case "saveUsers": {
      return {
        ...state,
        users: action.value.users
      }
    }
    case "saveAdminProjects": {
      return {
        ...state,
        adminProjects: action.value.adminProjects
      }
    }
    case "saveAdminModels": {
      return {
        ...state,
        adminModels: action.value.adminModels
      }
    }
    case "saveProjects": {
      return {
        ...state,
        projects: action.value.projects
      }
    }
    case "saveUnapprovedProjects": {
      return {
        ...state,
        unapprovedProjects: action.value.projects
      }
    }
    case "saveProjectNamesAndIdsOfUser": {
      return {
        ...state,
        projectNamesAndIdsOfUser: action.value.projectNamesAndIdsOfUser
      }
    }
    case "saveModels": {
      return {
        ...state,
        models: action.value.models
      }
    }
    case "saveUnapprovedModels": {
      return {
        ...state,
        unapprovedModels: action.value.models
      }
    }
    case "saveModelInputTypes": {
      return {
        ...state,
        modelInputTypes: action.value.modelInputTypes
      }
    }
    case "saveModelResultTypes": {
      return {
        ...state,
        modelResultTypes: action.value.modelResultTypes
      }
    }
    case "showAlert": {
      return {
        ...state,
        alertType: action.value.alertType,
        alertMessage: action.value.alertMessage,
        alertOpen: 1,
      };
    }
    case "closeAlert": {
      return {
        ...state,
        alertOpen: 0,
      };
    }
    case "sidebar": {
      return {
        ...state,
        sidebarOpen: state.sidebarOpen === "1" ? "0" : "1",
      };
    }
    case "logout": {
      return {
        ...initialState
      };
    }
    default: {
      return state;
    }
  }
}
